import { Pipe, PipeTransform } from '@angular/core';
export type BooleanIcon = 'check' | 'x';
const conversionMap = new Map<number | string, BooleanIcon>([
    [1, 'check'],
    [2, 'x'],
    ['Yes', 'check'],
    ['No', 'x']
]);

@Pipe({
    name: 'booleanIcon'
})
export class BooleanIconPipe implements PipeTransform {
    transform(value: number | string): BooleanIcon | '' {
        if (conversionMap.has(value)) {
            return conversionMap.get(value) ?? '';
        }

        return value ? 'check' : 'x';
    }
}
